import React from "react";
import { Typography } from "@mui/material";
import { ChevronIcon } from "shared/icons/ChevronArrIcon";

export const TitleCell = ({ title }: { title: string }) => (
  <>
    <Typography>{title}</Typography>
    <ChevronIcon direction="right" />
  </>
);
